// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__106VN","sendOtp":"AuthorizeToLogin_sendOtp__2XNF0"};